import axios from "axios";

export const frontendApiClient = axios.create({
    baseURL: process.env.NEXT_PUBLIC_FRONTEND_API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});

export const backendApiClient = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BACKEND_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});